import { render } from "./AddonView.vue?vue&type=template&id=23b2c25a&scoped=true&ts=true"
import script from "./AddonView.vue?vue&type=script&lang=ts"
export * from "./AddonView.vue?vue&type=script&lang=ts"

import "./AddonView.vue?vue&type=style&index=0&id=23b2c25a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b2c25a"]])

export default __exports__